<!-- ACTIVITY CARD 🚴 -->
<div id="activity" class="card">
  <!-- HEADER -->
  <div id="header">
    <div id="top">
      <img [src]="activity.sessions[activity.sessions_count - 1].user.avatar_url" alt="" />
      <div>
        <div id="username">{{ activity.sessions[0].user.username }}</div>
        <span id="date">
          <span [ngClass]="'icon icon-' + activity.sport"></span>
          {{
          activity.sessions[0].created_at * 1000
          | date: (settings$ | async)?.default_date_format
          }}</span>
      </div>

      <span id="mode-wrapper">
        <span id="mode">{{
          'training_log.mode.' + activity.mode | translate
          }}</span>

        @switch (activity.mode) {
        @case ('challenge') {
        <span class="icon icon-challenge-cup"></span>
        }
        @case ('discovery') {
        <span class="icon icon-star"></span>
        }
        @case ('coaching') {
        <span class="icon icon-coaching-new"></span>
        }
        @case ('workout') {
        <span class="icon icon-mode-interval"></span>
        }
        @case ('gps_only') {
        <span class="icon icon-map"></span>
        }
        @case ('free_ride') {
        <span class="icon icon-mode-freeride"></span>
        }
        @case ('outdoor') {
        <span class="icon icon-mode-outdoor"></span>
        }
        }
      </span>
    </div>
    <span id="title">{{ activity.name }}</span>
    @if (!activity.is_validated) {
    <span id="not-validated" translate>training_log.not_validated</span>
    }
  </div>

  <!-- CONTENT -->

  <div id="content">
    @if (!activity.is_validated) {
    <svg id="suspicious-svg" [class.active]="suspiciousSvgActive" width="616" height="683" viewBox="0 0 616 683"
      fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M221.869 3.33333C216.003 7.2 213.336 12.4 210.803 26C209.603 31.8667 208.136 39.6 207.336 43.3333C206.669 46.9333 205.736 51.7333 205.336 54C204.803 56.1333 204.003 60.6667 203.336 64C202.803 67.3333 201.603 73.4667 200.803 77.6C198.803 88.1333 196.803 99.0667 195.203 108.667C194.403 113.067 193.203 119.6 192.669 123.333C191.203 131.2 188.936 145.333 187.736 152.133C186.936 157.6 187.736 158.533 195.869 160.267C234.936 168.933 280.936 172.267 332.669 170.4C363.869 169.333 384.669 167.067 406.669 162.667C429.603 158.133 428.403 159.067 426.136 147.067C425.336 142 424.003 134.4 423.203 130C422.536 125.6 421.336 118.933 420.669 115.333C420.003 111.6 418.803 104.8 418.003 100C417.069 95.2 415.869 88.6667 415.336 85.3333C414.669 82 413.469 75.7333 412.669 71.3333C409.069 52.1333 408.403 48.4 407.336 43.3333C406.669 40.4 405.469 33.3333 404.536 27.6C402.403 14.9333 398.536 6.93333 392.669 2.93333C388.936 0.533325 386.536 0 377.203 0C371.069 0 364.803 0.533325 363.069 1.2C361.336 1.86667 357.603 3.06667 354.669 3.86667C351.736 4.79999 348.003 6.13333 346.403 6.8C344.669 7.46666 341.869 8.53333 340.003 9.33333C338.136 10 335.336 11.2 333.736 11.8667C323.603 16.1333 313.603 18.6667 307.336 18.6667C301.069 18.6667 291.069 16.1333 281.069 11.8667C279.336 11.2 276.403 10 274.403 9.2C272.269 8.39999 269.603 7.2 268.403 6.53333C267.069 5.86667 265.069 5.33333 264.003 5.33333C262.936 5.33333 260.936 4.79999 259.603 4.13333C253.869 1.2 247.069 0 237.203 0.133331C228.403 0.133331 225.869 0.666656 221.869 3.33333Z"
        fill="#1a1918" />
      <path
        d="M173.336 134.133C169.736 135.2 164.536 136.933 162.002 137.733C158.802 138.8 146.002 139.2 120.002 138.933C82.8025 138.667 74.2691 139.333 65.0691 143.467C59.6025 146 52.9358 153.867 50.5358 160.667C48.2691 167.333 48.1358 183.067 50.4025 189.6C55.3358 203.733 70.2691 217.867 91.0692 228.133C98.9358 231.867 106.802 235.6 108.669 236.4C110.536 237.067 113.069 238.133 114.269 238.8C115.602 239.467 117.602 240 118.669 240C119.736 240 121.736 240.533 123.069 241.2C124.269 241.867 127.469 242.933 130.002 243.6C142.936 247.333 146.802 248.533 147.869 249.467C148.402 250 144.536 252.533 139.202 255.2C122.002 263.467 103.336 274.667 98.1358 279.733C97.0692 280.667 94.6692 282.533 92.8025 283.733C80.1358 291.867 43.3358 330.667 43.3358 335.867C43.3358 338.267 54.4025 358.267 59.6025 365.333C67.3358 375.6 83.8692 392.4 93.3358 399.733C97.7358 403.067 101.602 406.267 102.002 406.667C103.202 408.267 130.669 426.267 138.669 430.667C150.136 437.067 166.802 445.467 176.669 449.733C184.802 453.333 187.069 454.267 194.402 457.2C203.069 460.667 207.469 462.933 206.802 463.6C206.002 464.533 192.936 460.933 184.002 457.333C182.536 456.8 179.202 455.6 176.669 454.667C174.136 453.733 170.802 452.533 169.336 452C167.869 451.467 163.069 449.6 158.669 447.867C147.202 443.6 113.069 426.933 106.402 422.533C100.402 418.4 99.2025 418 95.6025 419.867C94.4025 420.533 89.2025 423.067 84.0025 425.467C71.0692 431.6 53.6025 442 44.0025 449.2C31.8691 458.4 15.3358 475.467 7.73581 486.667C-1.59752 500.533 -1.73085 501.467 3.33581 509.467C26.4025 545.333 63.3358 585.467 96.6692 610.933C121.202 629.6 154.002 647.867 184.669 660C204.536 667.867 231.202 675.2 252.669 678.533C257.469 679.333 265.336 680.533 270.136 681.333C281.736 683.067 337.202 683.067 350.669 681.2C365.469 679.333 379.736 676.533 393.336 673.2C400.136 671.467 431.069 661.6 435.069 660C436.669 659.2 439.336 658.133 441.069 657.467C447.069 654.933 474.802 641.2 480.536 637.867C492.269 631.067 522.669 610.267 526.003 606.667C526.403 606.267 530.536 602.667 535.336 598.667C546.003 589.733 562.936 572.8 572.669 561.333C576.669 556.533 580.269 552.4 580.669 552C584.403 548.267 594.403 534.8 603.869 520.4L615.602 502.933L613.203 497.733C603.602 477.067 575.602 449.333 550.669 435.867C535.336 427.6 517.336 418.667 515.869 418.667C514.936 418.667 510.402 421.067 505.736 423.867C495.869 429.867 467.736 443.467 456.003 447.867C451.603 449.6 446.269 451.733 444.003 452.667C441.869 453.733 438.269 454.933 436.003 455.467C433.869 456 431.469 456.8 430.669 457.333C430.003 457.733 426.669 458.933 423.336 459.867C420.003 460.8 416.269 462.133 414.802 462.933C413.336 463.733 411.869 463.733 411.202 463.067C410.136 462 415.202 459.2 426.669 454.667C431.869 452.667 441.469 448.267 454.003 442.133C466.536 436 468.269 434.933 481.336 427.333C489.069 422.8 511.736 408 512.669 406.667C513.069 406.267 516.936 403.067 521.336 399.733C530.936 392.4 548.802 374 555.736 364.4C560.669 357.6 571.336 338 571.336 335.867C571.336 331.6 546.536 304.267 531.069 291.333C508.402 272.667 499.603 266.933 475.469 255.2C470.136 252.667 466.136 250 466.802 249.467C467.869 248.533 471.603 247.333 484.669 243.6C487.202 242.933 490.402 241.867 491.603 241.2C492.936 240.533 494.936 240 496.003 240C497.069 240 499.069 239.467 500.402 238.8C501.603 238.133 504.136 237.067 506.003 236.267C507.869 235.6 515.736 231.867 523.469 228.133C544.936 217.6 556.003 207.333 564.936 189.067C566.669 185.333 566.136 166.533 564.136 160.667C561.736 153.867 555.069 146 549.602 143.467C540.536 139.333 531.736 138.667 494.669 138.933C456.669 139.2 452.536 138.8 438.802 133.467C436.669 132.533 434.669 132.133 434.402 132.4C433.869 132.933 435.469 145.333 438.136 162.667C440.936 180.533 441.603 188.667 440.536 190.133C439.869 190.933 436.536 192 432.936 192.533C429.469 192.933 423.736 194 420.003 194.667C379.603 202.533 356.136 204.667 308.669 204.667C259.602 204.667 234.669 202.533 194.669 194.667C191.069 194 185.202 192.933 181.736 192.533C178.136 192 174.802 190.933 174.136 190.133C173.069 188.667 173.736 180.8 176.536 162.667C177.336 157.867 178.536 150 179.202 145.2C180.002 140.4 180.936 135.467 181.469 134.133C182.402 131.6 182.002 131.6 173.336 134.133ZM185.336 256C222.802 262 244.269 263.333 307.336 263.333C375.202 263.333 391.469 262.133 442.802 253.733C448.003 252.933 448.802 254 447.336 260.667C446.669 263.6 445.469 270.133 444.669 275.333C442.936 286 440.802 296.533 439.336 301.333C438.802 303.2 437.603 307.333 436.669 310.667C430.936 330.8 424.003 349.067 416.669 363.333C411.336 373.467 405.869 382.933 404.669 384C404.269 384.4 401.603 388.267 398.669 392.533C392.402 402 369.069 425.867 360.936 431.467C342.136 444 335.602 447.733 316.136 456.667C310.402 459.467 304.669 459.733 300.269 457.733C274.936 445.733 261.469 438.133 255.602 432.4C254.669 431.467 253.336 430.667 252.802 430.667C249.069 430.667 211.336 389.6 211.336 385.467C211.336 384.8 210.802 384 210.269 383.733C208.936 383.2 204.402 375.6 198.002 363.333C188.002 344 177.336 313.067 172.669 289.333C171.869 285.333 170.669 279.467 169.869 276.267C169.202 273.2 168.669 268.933 168.669 266.8C168.669 264.533 168.002 261.2 167.336 259.333C165.469 254.533 166.802 252.933 171.869 253.733C174.136 254.133 180.269 255.067 185.336 256Z"
        fill="#1a1918" />
      <path
        d="M186.669 274.267C189.869 299.733 201.736 316 221.869 322.533C231.869 325.867 255.202 326.4 265.469 323.733C274.136 321.333 281.602 314.533 286.136 304.533C297.202 280.667 318.136 281.067 329.202 305.6C333.069 314 341.202 321.867 347.736 323.333C350.136 323.867 359.069 324.533 367.736 324.933C381.336 325.467 384.802 325.067 392.402 322.667C412.802 316.133 424.936 300.267 428.002 276.133L428.936 268.933L423.202 270C413.336 271.6 400.669 273.2 384.002 274.667C375.202 275.467 367.069 276.4 366.002 276.8C362.402 278.133 266.002 277.467 252.269 276.133C217.336 272.4 211.602 271.733 205.336 270.667C201.736 270 195.736 269.067 192.269 268.667L185.869 267.867L186.669 274.267Z"
        fill="#1a1918" />
    </svg>
    }
    <div id="content-scroll">
      @switch (activity.mode) {
      <!--* COACHING 🏋️ -->
      @case ('coaching') {
      <div class="element coaching-resume" id="resume" #resume>
        <span class="gradient">
          @for (info of trainingLogInfos; track $index) {
          <div class="info">
            <p class="data">{{ info.data }}</p>
            <p class="label">{{ info.label | lowercase }}</p>
            <span class="icon" [ngClass]="'icon-' + info.icon"></span>
            @if (!$last) {
            <span class="divider"></span>
            }
          </div>
          }
        </span>
        <img class="background" [src]="activity.thumbnails.large" />
      </div>
      }

      <!--* GPS ONLY 🗺️ -->
      @case ('gps_only') {
      <div class="element gps-only-resume" id="resume" #resume>
        <span class="gradient">
          @for (info of trainingLogInfos; track $index) {
          <div class="info">
            <p class="data">{{ info.data }}</p>
            <p class="label">{{ info.label | lowercase }}</p>
            <span class="icon" [ngClass]="'icon-' + info.icon"></span>
            @if (!$last) {
            <span class="divider"></span>
            }
          </div>
          }
        </span>
        <img class="background" [src]="activity.thumbnails.large" />
      </div>
      }

      <!--* GPS ONLY 🗺️ -->
      @case ('outdoor') {
      <div class="element gps-only-resume" id="resume" #resume>
        <span class="gradient">
          @for (info of trainingLogInfos; track $index) {
          <div class="info">
            <p class="data">{{ info.data }}</p>
            <p class="label">{{ info.label | lowercase }}</p>
            <span class="icon" [ngClass]="'icon-' + info.icon"></span>
            @if (!$last) {
            <span class="divider"></span>
            }
          </div>
          }
        </span>
        <img class="background" [src]="activity.thumbnails.large" alt="" />
      </div>
      }

      @case ('free_ride') {
      <div class="element free_ride-resume" id="resume" #resume (click)="scroll(resume)">
        <span class="gradient">
          @for (info of trainingLogInfos; track $index) {
          <div class="info">
            <p class="data">{{ info.data }}</p>
            <p class="label">{{ info.label | lowercase }}</p>
            <span class="icon" [ngClass]="'icon-' + info.icon"></span>
            @if (!$last) {
            <span class="divider"></span>
            }
          </div>
          }
        </span>
        <img class="background" [src]="activity.thumbnails.large"
          srcset="https://static.kinomap.com/free_ride_dev/free_ride.jpg" alt="the free ride illustration." />
      </div>
      }

      <!--* WORKOUT  🏃 -->
      @case ('workout') {
      <div class="element workout-resume" id="resume" #resume>
        <span class="gradient">
          @for (info of trainingLogInfos; track $index) {
          <div class="info">
            <p class="data">{{ info.data }}</p>
            <p class="label">{{ info.label | lowercase }}</p>
            <span class="icon" [ngClass]="'icon-' + info.icon"></span>
            @if (!$last) {
            <span class="divider"></span>
            }
          </div>
          }
        </span>
        <img class="background" [src]="workoutImgUrl" alt="The empty workout illustration" />
      </div>
      }

      <!--* challenge -->
      @case ('challenge') {
      <div class="element" id="resume" #resume (click)="scroll(resume)">
        <span class="gradient">
          @for (info of trainingLogInfos; track $index) {
          <div class="info">
            <p class="data">{{ info.data }}</p>
            <p class="label">{{ info.label | lowercase }}</p>
            <span class="icon" [ngClass]="'icon-' + info.icon"></span>
            @if (!$last) {
            <span class="divider"></span>
            }
          </div>
          }
        </span>
        <img class="background" [src]="activity.thumbnails.large" alt="" />
      </div>
      <div class="element" #map id="map" (click)="scroll(map)">
        <img [src]="activity.map_thumbnail" alt="" />
      </div>
      }

      <!--* discovery -->
      @case ('discovery') {
      <div class="element" id="resume" #resume (click)="scroll(resume)">
        <span class="gradient">
          @for (info of trainingLogInfos; track $index) {
          <div class="info">
            <p class="data">{{ info.data }}</p>
            <p class="label">{{ info.label | lowercase }}</p>
            <span class="icon" [ngClass]="'icon-' + info.icon"></span>
            @if (!$last) {
            <span class="divider"></span>
            }
          </div>
          }
        </span>
        <img class="background" [src]="activity.thumbnails.large" alt="" />
      </div>
      <div class="element" #map id="map" (click)="scroll(map)">
        <img [src]="activity.map_thumbnail" alt="" />
      </div>
      }

      <!--* default -->
      @default {
      <div class="element" id="resume" #resume (click)="scroll(resume)">
        <span class="gradient">
          @for (info of trainingLogInfos; track $index) {
          <div class="info">
            <p class="data">{{ info.data }}</p>
            <p class="label">{{ info.label | lowercase }}</p>
            <span class="icon" [ngClass]="'icon-' + info.icon"></span>
            @if (!$last) {
            <span class="divider"></span>
            }
          </div>
          }
        </span>
        <img class="background" [src]="activity.thumbnails.large" alt="" />
      </div>
      <div class="element" #map id="map" (click)="scroll(map)">
        <img [src]="activity.map_thumbnail" alt="" />
      </div>
      }
      }
    </div>
  </div>

  <!-- FOOTER -->
  <div id="footer">
    <div>
      <span id="counter">{{ activity.completion_percent }}%</span>
      <span id="progress-bar">
        <span id="bar" [ngStyle]="{ width: completion_percent + '%' }"></span>
      </span>
    </div>
    @if(activity.sessions_count > 1){
    <span class="activity-session-list" (click)="activitySessionListClick()">Récapitulatif des sessions ({{
      activity.sessions_count }})</span>
    }
  </div>
</div>